<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :url="url"
      :title="$lang.searchExercise"
      :remove_item="remove_item"
      addModalSize="lg"
      removeModalSize="xl"
      :toggleable="true"
      config="exercise"
      :dynamicButtons="buttons"
    >
      <template slot="addModal" slot-scope="search">
        <AddExercise isModal @modal-end-up="search.close"></AddExercise>
      </template>
    </Search>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddExercise from "./addExercise";

export default {
  components: {
    Search,
    AddExercise,
  },
  data() {
    return {
      loadingItem: false,
      url: this.$config.api_url + this.$config.kanoon.exercise,
      buttons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "view",
        },
        {
          id: "2",
          name: "enable",
        },
        {
          id: "3",
          name: "delete",
        },
      ],
    };
  },
  methods: {
    editItem(item) {},
    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
  },
};
</script>
